export default __webpack_public_path__ + "static/media/2223 utensils top.f15a78d5.png";